import React, { useEffect, useRef, useState } from 'react';

function useCountUp(target: number, duration: number, active: boolean) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let v = 0;
    const step = target / (duration / 16);
    const t = setInterval(() => {
      v += step;
      if (v >= target) { setCount(target); clearInterval(t); }
      else setCount(Math.floor(v));
    }, 16);
    return () => clearInterval(t);
  }, [active, target, duration]);
  return count;
}

const About: React.FC = () => {
  const ref = useRef<HTMLElement>(null);
  const [active, setActive] = useState(false);
  const projects   = useCountUp(20, 1000, active);
  const clients    = useCountUp(7,   700, active);
  const experience = useCountUp(6,   700, active);
  const team       = useCountUp(10,  900, active);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(true);
            entry.target.querySelectorAll('.reveal').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="about" id="about" ref={ref}>
      <div className="container">
        <div className="about-inner">
          <div className="about-text">
            <div className="reveal">
              <span className="section-label">About Us</span>
              <h2>A technology partner you<br />can <span className="gt">count on</span></h2>
            </div>
            <p className="reveal d1">
              We're a focused team out of Surat. We work on AI, automation, and
              software. We only take on projects where we're confident we can
              actually move the needle for our clients.
            </p>
            <p className="reveal d2">
              Most of the people who come to us have hit a wall with their existing
              tech. It doesn't scale, it doesn't talk to their other tools, or it
              was built for a business they no longer run. We fix that.
            </p>
            <div className="about-stats reveal d3">
              <div className="stat-item">
                <div className="stat-value">{projects}+</div>
                <div className="stat-label">Projects</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{clients}+</div>
                <div className="stat-label">Clients</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{experience}+</div>
                <div className="stat-label">Yrs Experience</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{team}+</div>
                <div className="stat-label">Team Size</div>
              </div>
            </div>
          </div>

          <div className="about-visual reveal d2">
            <div className="about-card">
              <div className="ac-glow-1" /><div className="ac-glow-2" />
              <div className="status-badge">
                <span className="status-dot" />
                Available for new projects
              </div>
              <p className="about-tagline">
                Based in Surat, India.<br />
                Working with clients across India &amp; internationally.
              </p>
              <div className="tech-tags">
                {['React', 'Python', 'Node.js', 'AI / ML', 'LangChain', 'n8n', 'AWS', 'FastAPI'].map(t => (
                  <span className="tech-tag" key={t}>{t}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
